import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filterSelectors } from '../Modules/filters';
import { getTimezone } from 'reducers/utils';
import { transformVisitorList } from 'utils/DataTransform/Visitor/VisitorList';
import { transformVisitorDetails } from 'utils/DataTransform/Visitor/VisitorDetails';
//--------------------- Generic Selectors ---------------------------------------
export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getFilters = createSelector(
  filterSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
//-------------------------Specific Selectors ------------------------------
export const getVisitorSignedOut = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details || Object.keys(details).length === 0) {
      return {};
    }
    return false;
  },
);

export const getVisitorListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getTimezone,
  (list, timeZone) => {
    if (!list) return [];
    return transformVisitorList(list, timeZone);
  },
);
export const getVisitorListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (!list) return [];
    return list;
  },
);

export const getVisitorDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getTimezone,
  (details, timeZone) => {
    if (!details || Object.keys(details).length === 0) {
      return {};
    }
    return transformVisitorDetails({ data: details, timeZone });
  },
);
export const getVisitorDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details || Object.keys(details).length === 0) {
      return {};
    }
    return details;
  },
);
